import NotificationManager from "../../utils/class/notifications";

const LOADER_DELAY = 2000;

export default class JobPaymentConfirm {
    constructor () {
        this.NotificationManager = new NotificationManager();

        this.searchParams = new URLSearchParams(window.location.search);

        if (this.searchParams.get('rejected') === 'true') return;

        this.sessionID = this.searchParams.get('session_id');

        this.loadingEl = document.querySelector('#proccess-loading');
        this.successEl = document.querySelector('#proccess-success');
        this.errorEl = document.querySelector('#proccess-error');

        if (!this.sessionID) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Session ID is not provided.');

            this.loadingEl.classList.add('hidden');

            this.successEl.classList.add('hidden');
            this.errorEl.classList.remove('hidden');

            return;
        };

        this.init();
    }

    async init () {
        try {
            await fetch('/wp-json/jobs/v1/confirm', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ sessionID: this.sessionID })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.NotificationManager.sendNotification('success', 'Thank you!', 'Your payment has been confirmed!');

                    setTimeout(() => {
                        this.loadingEl.classList.add('hidden');

                        this.successEl.classList.remove('hidden');
                        this.errorEl.classList.add('hidden');
                    }, LOADER_DELAY);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Your payment failed. Please, contact support.');

                    setTimeout(() => {
                        this.loadingEl.classList.add('hidden');
    
                        this.successEl.classList.add('hidden');
                        this.errorEl.classList.remove('hidden');
                    }, LOADER_DELAY);
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Your payment failed. Please, contact support.');

                this.loadingEl.classList.add('hidden');

                this.successEl.classList.add('hidden');
                this.errorEl.classList.remove('hidden');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Your payment failed. Please, contact support.');

            this.loadingEl.classList.add('hidden');

            this.successEl.classList.add('hidden');
            this.errorEl.classList.remove('hidden');
        }
    }
}
